import React, { useState } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

import BaseFilter, {
  FilterTypeEnum,
} from '../../../components/base/BaseFilter';
import { ArrayStringData } from 'utils';

function Filter({ backAction = () => {} }) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search);
  const searchAdminType = parsedSearch['admin_type'] || '';
  const searchStatus = parsedSearch['status'] || '';

  const [adminType, setAdminType] = useState(ArrayStringData(searchAdminType));
  const [status, setStatus] = useState(searchStatus);

  const content = [
    {
      title: 'Admin type',
      data: [
        { name: 'CMS Admin Users', pk: 'ORDINARY_CMS_ADMIN' },
        { name: 'CMS Super Admin Users', pk: 'SUPER_CMS_ADMIN' },
        { name: 'Merchant App Users', pk: 'MERCHANT_APP_ACCOUNT' },
      ],
      value: adminType,
      setValue: setAdminType,
      component: FilterTypeEnum.choice,
    },
    {
      title: 'Status',
      data: [
        { name: 'Active', pk: 'true' },
        { name: 'Inactive', pk: 'false' },
      ],
      value: status,
      setValue: setStatus,
      component: FilterTypeEnum.singleChoiceSegment,
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default Filter;
